import ConsignmentBooking from "../Booking/ConsignmentBooking";

/**
 * Mobile Version — this does NOT duplicate the booking form.
 * It calls the exact same ConsignmentBooking.jsx and just flips the
 * `variant` flag to "mobile", which hides the fields we don't want on
 * the mobile screen (see the `isMobile` checks inside ConsignmentBooking.jsx).
 *
 * Any future change to the booking logic, layout, or field-hiding rules
 * only ever needs to happen in ConsignmentBooking.jsx — this file just
 * calls it with the mobile flag on.
 */
export default function MobileVersion() {
  return <ConsignmentBooking variant="mobile" />;
}
//